import { SET_HAS_PENDING_EDITS_V3, CLEAR_PENDING_EDITS_V3 } from 'lib/constants/v3Actions';

const initialState = {
  isPending: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_HAS_PENDING_EDITS_V3:
      return {
        ...state,
        isPending: true,
      };
    case CLEAR_PENDING_EDITS_V3:
      return {
        ...state,
        isPending: false,
      };
    default:
      return state;
  }
};
